import axios from 'axios'
import util from '../util';
import constants from "../constants";

const isTestEnv = location.hostname.match('test.mhmfun.com');

const base = (util.isLocalhost() ? 'http://localhost:8085/oo'
                    : isTestEnv ? `${util.getShortDomain()}/oo`
                        : util.getShortDomain(true))
                    + '/api/v1';

const BUSINESS_PATH = `${base}/public/businesses`;

export const ops = () => {
    const user = "oo-service";
    const pwd = "th3OOs3rv1c31s@m@z1n!-2!";
    return btoa(user + ":" + pwd)
};

const getStatusForMember = (memberId) => {
    return axios.get(`${BUSINESS_PATH}/statusById`, {
        params: { memberId },
        headers: {
            'token': ops()
        }
    });
};

const getBusinessLocation = (locationId) => {
    return axios.get(`${BUSINESS_PATH}/${locationId}/location`, {
        headers: {
            'token': ops()
        }
    });
};

const getStatusForBusiness = (businessId) => {
    return axios.get(`${BUSINESS_PATH}/${businessId}/status`, {
        headers: {
            'token': ops()
        }
    });
};

export default {
    getStatusForMember,
    getBusinessLocation,
    getStatusForBusiness,
}
